import React from 'react'
import './Welcome.css'
import Button from '@material-ui/core/Button'
import db from '../Firebase'


function Welcome() {
    const addChannel = () => {
        const channelName =prompt('please enter the channel name')
        if(channelName){
             db.collection('rooms').add({
                 name:channelName
             })
        }
    }
    return (
        <div className="welcome">
            <div className="welcome__container">
                <h1 className="welcome__header">Welcome to slack clone made by Amine ladraa</h1>
                <p className="welcome__text">create a room from the side or click here</p>
                <Button variant="contained" onClick={addChannel} disableElevation>New Channel</Button>
            </div>
            
        </div>
    )
}

export default Welcome
